import { createSelector } from 'reselect';

const aspynMigratorSelector = (state) => state.aspynMigrator;

export const aspynResultSelector = createSelector(
  aspynMigratorSelector,
  (aspynMigrator) => aspynMigrator?.aspynResult,
);

export const aspynHousingResultSelector = createSelector(
  aspynMigratorSelector,
  (aspynMigrator) => aspynMigrator?.aspynHousingResult,
);

export const migrationJobsSelector = createSelector(
  aspynMigratorSelector,
  (aspynMigrator) => aspynMigrator?.migrationJobs?.data || [],
);

export const migrationJobsMetaSelector = createSelector(
  aspynMigratorSelector,
  (aspynMigrator) => aspynMigrator?.migrationJobs?.meta,
);

export const migrationJobsTotalSelector = createSelector(
  migrationJobsMetaSelector,
  (meta) => meta?.total || 0,
);
